import React from "react";
import { Form, InputNumber, Input, Select } from "antd";
import UniDropAdv from "../UniDrop/UniDropAdv";

function MultipleInput({
  form,
  name,
  label,
  width,
  inputType,
  numberOfFields,
  required,
  minRequired,
  errorMessage,
  validateFunction,
  defaultValue,
  placeholder,
  disabled,
  onChange,
  dropDownData,
  multiSelect,
  sourceParams,
  pname,
  searchable,
  includeAll
}) {
  //  form.setFieldsValue({ [name]: defaultValue });

  const getFieldType = (
    fieldType,
    name,
    index,
    defaultValue,
    placeholder,
    disabled
  ) => {
    switch (fieldType) {
      case "int":
      case "decimal":
        return (
          <Input
            disabled={disabled}
            onChange={onChange ? onChange : () => { }}
            type="number"
            step={fieldType === "int" ? "1" : "0.1"}
            style={{
              width: "100px",
              backgroundColor: "#fff",
              fontWeight: 600,
              margin: "0 10px",
            }}
            defaultValue={defaultValue}
            placeholder={placeholder}
          />
        );
        break;
      case "text":
        return (
          <Input
            disabled={disabled}
            onChange={onChange ? onChange : () => { }}
            style={{
              width: "100px",
              backgroundColor: "#fff",
              fontWeight: 600,
              margin: "0 10px",
            }}
            defaultValue={defaultValue}
            placeholder={placeholder}
          />
        );
        break;
      case 'dropdown':
        let __data = [];
        Object.keys(dropDownData).forEach(x => {
          __data.push({ label: dropDownData[x], value: x })
        })
        return (
          <Select
            style={{
              width: "100px",
              backgroundColor: "#fff",
              fontWeight: 600,
              margin: "0 10px",
            }}
            className="storm-select"
            options={__data}
            onChange={onChange ? onChange : () => { }}
          />
        )
      default:
        return (
          <Input
            disabled={disabled}
            onChange={onChange ? onChange : () => { }}
            style={{
              width: "100px",
              backgroundColor: "#fff",
              fontWeight: 600,
              margin: "0 10px",
            }}
            defaultValue={defaultValue}
            placeholder={placeholder}
          />
        );
        break;
    }
  };

  const getInputField = (
    numberOfFields,
    fieldType,
    name,
    defaultValue,
    placeholder,
    disabled
  ) => {
    console.log(numberOfFields)
    return (
      <Input.Group compact
        style={{ display: 'flex', flexDirection: 'row', width: '100%', flexWrap: 'wrap', justifyContent: 'flex-start' }}
      >
        {[...Array(numberOfFields)].map((elem, idx) => {
          return (
            <Form.Item
              style={{ width: fieldType === 'dropdown' ? '20%' : 'auto' }}
              key={name + "input" + idx}
              name={[name, idx]}
              initialValue={defaultValue ? defaultValue[idx] : null}
              rules={[
                { required: required, message: errorMessage }
              ]}
            >
              {getFieldType(
                fieldType,
                name,
                idx,
                defaultValue ? defaultValue[idx] : null,
                placeholder,
                disabled
              )}
            </Form.Item>

          )
        })}
      </Input.Group>
    );
  };

  return (
    <Form.Item
      name={name}
      label={label}
      style={{ width: width, fontWeight: 600 }}
      rules={[
        {
          required: required,
          message: errorMessage,
        },
        () => ({
          validator(rule, value, sd, d) {
            if (minRequired) {
              if (
                !value ||
                (value &&
                  value.filter((val) => val && val.trim() !== "").length <
                  minRequired)
              ) {
                return Promise.reject(
                  errorMessage
                    ? errorMessage
                    : `Please enter at-least ${minRequired} values`
                );
              }
            }
            return validateFunction
              ? validateFunction(rule, value)
              : Promise.resolve();
          },
        }),
      ]}
    >
      {getInputField(
        numberOfFields,
        inputType,
        name,
        defaultValue,
        placeholder,
        disabled
      )}
    </Form.Item>
  );
}

export default MultipleInput;
